export default "__VITE_ASSET__Dj6G1i$R__"